window.addEventListener("load", function () {
//   const canvas = document.getElementById("progressCanvas");
// const ctx = canvas.getContext("2d");

// // Vẽ đường nền tím
// ctx.lineWidth = 15;
// ctx.strokeStyle = "#6648db";
// ctx.lineCap = "round";
// ctx.lineJoin = "round";

// ctx.beginPath();
// ctx.moveTo(50, 50);           // Start
// ctx.lineTo(600, 50);          // Đường ngang
// ctx.arcTo(625, 50, 625, 75, 25);  // Góc phải trên bo
// ctx.lineTo(625, 230);         // Xuống
// ctx.arcTo(625, 255, 600, 255, 25); // Góc phải dưới bo
// ctx.lineTo(50, 255);          // Qua trái
// ctx.stroke();

// // Vẽ đường tiến độ trắng (10%)
// ctx.beginPath();
// ctx.setLineDash([600, 1300]); // Giống stroke-dasharray
// ctx.lineDashOffset = 0;
// ctx.strokeStyle = "white";
// ctx.moveTo(50, 50);
// ctx.lineTo(600, 50);
// ctx.arcTo(625, 50, 625, 75, 25);
// ctx.lineTo(625, 230);
// ctx.arcTo(625, 255, 600, 255, 25);
// ctx.lineTo(50, 255);
// ctx.stroke();

   const grArtSwiper = new Swiper(".gr_artSwiper", {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: ".swiper-button-next.artNext",
    prevEl: ".swiper-button-prev.artPrev",
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  loop: false, // hoặc true nếu muốn lặp
  // autoplay: {
  //   delay: 5000, // 5 giây
  //   disableOnInteraction: false // vẫn tự chạy sau khi người dùng tương tác
  // }
});


 //const pointLevel = 100; // ✅ Điểm hiện tại

const $levelList = $(".gr_artSwiper .gr_art--item").map(function () {
  return {
    level: parseInt($(this).data("level")),
    exp: parseInt($(this).data("exp")),
  };
}).get();

// Frame2 giờ nằm trong iframe dotpha. File này vẫn nằm trong bundle chính (trang cha) nhưng
// trang cha không có phần tử Frame2 → bỏ qua để tránh lỗi đọc $levelList[0].exp.
if ($levelList.length === 0) return;

const $level = $(".levelup__number");
//const $turn = $(".turn"); // cập nhật số điểm hiển thị
const $exp = $(".group__level--exp span");
const $levelBar = $(".group__level--progress-bar-fill .overlay");
const $featureList = $(".gr_artSwiper .gr_art--item");
const maxPoint = 1000;
const percent = pointLevel / maxPoint;

// ✅ Vẽ tiến trình canvas
function drawProgressPath(percent) {
  const canvas = document.getElementById("progressCanvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height); // Xóa cũ

  // Thiết lập style chung
  ctx.lineWidth = 11;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";

  // Tạo path bo góc
  const createPath = () => {
    const path = new Path2D();
    path.moveTo(50, 50);                            // Điểm bắt đầu
    path.lineTo(600, 50);                           // Đường ngang
    path.arcTo(625, 50, 625, 75, 25);               // Góc bo phải trên
    path.lineTo(625, 230);                          // Xuống dọc
    path.arcTo(625, 255, 600, 255, 25);             // Góc bo phải dưới
    path.lineTo(50, 255);                           // Qua trái
    return path;
  };

  const path = createPath();

  // Vẽ nền track (cam nhạt) — khớp mockup
  ctx.strokeStyle = "#f6c874";
  ctx.setLineDash([]);
  ctx.stroke(path);

  // Vẽ tiến độ cam. `percent` (0..1) = tỉ lệ đã tô DỌC THEO chiều dài đường (arc-length),
  // do getLevelBarMobile() tính sẵn theo vị trí mốc trên layout rắn bò — không cộng offset nữa.
  const totalLength = 1333; // 550(trên) + 39.3(cong) + 155(dọc) + 39.3(cong) + 550(dưới)
  const progressLength = Math.min(totalLength * percent, totalLength);

  ctx.strokeStyle = "#f55c06";
  ctx.setLineDash([progressLength, totalLength]);
  ctx.lineDashOffset = 0;
  ctx.stroke(path);
}

// ✅ Tính level hiện tại
const getLevel = (point) => {
  let level = 0;
  let exp = 0;
  if (point < $levelList[0].exp) {
    level = 0;
    exp = $levelList[0].exp;
  } else if (point >= $levelList[$levelList.length - 1].exp) {
    level = $levelList[$levelList.length - 1].level;
    exp = $levelList[$levelList.length - 1].exp;
  } else {
    for (let i = 1; i < $levelList.length; i++) {
      if (point < $levelList[i].exp) {
        level = $levelList[i - 1].level;
        exp = $levelList[i].exp;
        break;
      }
    }
  }
  return { level, point, exp };
};

// ✅ Tính phần trăm fill thanh tiến độ dựa trên điểm hiện tại (.levelup__number)
// Mốc điểm đột phá cần đạt của 8 mốc phần thưởng:
const mocExp = [50, 150, 280, 520, 700, 920, 1100, 1300];
// Vị trí % của từng mốc trên thanh — khớp toạ độ tâm mốc trên PC:
// bar left 592 → mốc 8 tâm 1580 (rộng 988px). Mốc 8 cách xa hơn nên KHÔNG chia đều 100/7.
const mocPercent = [0, 14.02, 28.09, 42.16, 56.22, 70.29, 84.36, 100];

const getLevelBar = (point) => {
  // Chưa đạt mốc 1 → thanh rỗng
  if (point <= mocExp[0]) return 0;

  // Nội suy tuyến tính giữa 2 mốc liền kề để cạnh fill trùng vị trí mốc
  for (let i = 1; i < mocExp.length; i++) {
    if (point < mocExp[i]) {
      const segmentProgress = (point - mocExp[i - 1]) / (mocExp[i] - mocExp[i - 1]);
      return mocPercent[i - 1] + segmentProgress * (mocPercent[i] - mocPercent[i - 1]);
    }
  }

  // Đạt/vượt mốc cuối
  return 100;
};

// ✅ Tính % fill cho MOBILE (canvas rắn bò) — cùng bộ điểm mốc `mocExp`
// nhưng ánh xạ sang vị trí DỌC THEO chiều dài đường canvas (arc-length),
// vì layout mobile 2 hàng + đoạn cong nối nên mốc KHÔNG chia đều như PC.
//   Hàng trên (moc1→4, trái→phải): ~7,17,27,38%
//   Đoạn cong dọc (không có mốc):   38%→66%
//   Hàng dưới (moc5→8, phải→trái):  ~66,77,87,100%
const mocPercentMb = [7, 17, 27, 38, 66, 77, 87, 100];

const getLevelBarMobile = (point) => {
  // Trước mốc 1: tô dần từ đầu đường tới vị trí mốc 1
  if (point <= mocExp[0]) return (point / mocExp[0]) * mocPercentMb[0];

  for (let i = 1; i < mocExp.length; i++) {
    if (point < mocExp[i]) {
      const segmentProgress = (point - mocExp[i - 1]) / (mocExp[i] - mocExp[i - 1]);
      return mocPercentMb[i - 1] + segmentProgress * (mocPercentMb[i] - mocPercentMb[i - 1]);
    }
  }

  return 100;
};

// ✅ Đánh dấu các ảnh level đã đạt
const getFeature = (level, point) => {
  if (level >= 0 && point > 0) {
    $featureList.each(function () {
      if ($(this).index() <= level) {
        $(this).addClass("levelup");
      }
    });
  }
};

// ✅ Cập nhật giao diện
function updateLevelUI(pointLevel) {
  const { level, point, exp } = getLevel(pointLevel);

  $level.text(point); // hiện điểm
 // $turn.text(point); // hiện điểm ở .turn
  $exp.text(`${point}/${exp}`);

  // thanh overlay
  const levelBar = getLevelBar(point);
  $levelBar.css("width", `${levelBar}%`);

  // canvas (mobile) — tô theo vị trí mốc dọc đường rắn bò
  drawProgressPath(getLevelBarMobile(point) / 100);

  // levelup ảnh
  $featureList.removeClass("levelup");
  getFeature(level, point);

  // swiper
  if ($(".gr_artSwiper").length > 0) {
    const swiperInstance = $(".gr_artSwiper")[0].swiper;
    if (swiperInstance) {
      swiperInstance.slideTo(level, 0);
    }
  }
}

// ✅ Khởi chạy
updateLevelUI(pointLevel);

// ✅ Cho phép gọi lại từ bên ngoài
window.updateLevelUI = updateLevelUI;

// ✅ Tự cập nhật thanh tiến độ khi số điểm (.levelup__number) bị thay đổi từ bên ngoài
let lastPoint = pointLevel;
const levelNumberEl = $level.get(0);
if (levelNumberEl) {
  const numberObserver = new MutationObserver(function () {
    const newPoint = parseInt($level.text().replace(/[^\d]/g, ""), 10) || 0;
    if (newPoint === lastPoint) return; // bỏ qua thay đổi do chính updateLevelUI ghi ra → tránh loop
    lastPoint = newPoint;
    updateLevelUI(newPoint);
  });
  numberObserver.observe(levelNumberEl, { childList: true, characterData: true, subtree: true });
}


});
